import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useGetItemQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as revisionDocumentApi from "../../api/documentApi/revisionDocumentApi";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";

import {initializeChangeRequestListParams} from "../../models/serverModels/workOrder/EQChangeRequest";
import {
  EQRevisionDocument,
  initializeRevisionDocument,
  revisionTypeNames,
} from "../../models/serverModels/workOrder/EQRevisionDocument";
import RevisionDocumentForm from "./RevisionDocumentForm";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {revisionDocumentSchema} from "../../validation/revisionDocumentSchema";

const UpdateRevisionDocument = () => {
  const {id} = useParams();
  const {state} = useLocation();

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: revisionDocument, isLoading: isGetLoading} = useGetItemQuery<
    ResponseItem<EQRevisionDocument>
  >({
    key: ["RevisionDocument", id],
    api: () =>
      revisionDocumentApi.getItem({
        ...initializeChangeRequestListParams,
        token: tokenState,
        id: parseInt(id!),
      }),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EQRevisionDocument>,
    Params.Update<EQRevisionDocument>
  >({
    api: revisionDocumentApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate(`/Document/ListRevision/${state}`);
        queryClient.invalidateQueries("RevisionDocumentList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<EQRevisionDocument>({
    defaultValues: revisionDocument?.item || initializeRevisionDocument(state),
    resolver: yupResolver(revisionDocumentSchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(revisionDocument?.item);
  }, [revisionDocument?.item, reset]);

  const onSubmit: SubmitHandler<EQRevisionDocument> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeRevisionDocument(state), ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle={revisionTypeNames[state]} />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <RevisionDocumentForm subText="파일 수정" captionColor="#546E7A" />
            <ConfirmButtonGroup
              link={`/Document/ListRevision/${state}`}
              cancelText="취소"
              confirmText="수정"
            />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateRevisionDocument;
